import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import images from '../../../images';
import Lesson from '../../../common/Lesson';
import { __ } from '../../../locales';
import { iframeCall } from '../../../helpers/iframeHelper';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import CustomButton from '../../../common/CustomButton';

const Container = styled.div`
  padding: 25px 0px;
  padding-right: 0;
`;

const Content = styled.ul`
  height: 100px;
  overflow-x: scroll;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  margin-right: -12px;
  margin-left: -12px;
  padding-left: 12px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  margin-bottom: 10px;
`;

const BodyText = styled.p`
  margin-bottom: 5px;
  line-height: 1.4em;
`;

const Done = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  margin-right: 8px;
  margin-top: 4px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(${images.done});
`;

const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TakeTheQuizContainer = styled.div`
  display: block;
  padding: 10px 0px;
`;

const LearningModules = ({
  lessons,
  quizData,
  hasPassedLmQuiz,
  accountId,
  lmIndex,
  learningModulesRedux,
  notificationData,
  hasLmNotification,
  viewedLearningModules
}) => {
  const { push } = useHistory();
  const lessonRef = useRef();
  const lmQuiz = quizData.lmQuiz[lmIndex] || {};
  const lessonContentRef = useRef();

  useEffect(() => {
    if (notificationData?.campaign_id && hasLmNotification
      && Object.values(lessons).map((i) => i.id).includes(+notificationData?.campaign_id)) {
      onClick(+Object.keys(lessons)[0]);
    }
  }, [hasLmNotification]);

  const onClick = (id) => {
    const lesson = Object
      .keys(lessons)
      .map((key) => lessons[key])
      .find(({ activityId: lId }) => id === lId);

    trackEvent(
      'DZ_HOME_LM_ITEM_TAP',
      {
        activity_id: lesson.activity.coachable_id,
        campaign_id: lesson.id
      }
    );
    push(`/lesson-details/lm/${id}`, { ...lesson, lmIndex });
  };

  const createAccount = () => {
    trackEvent(events.DZ_HOME_SIGNUP_CTA_TAP);
    iframeCall('dzSignup');
  };

  const didCompleteLessons = Object
    .keys(lessons)
    .map((key) => lessons[key])
    .every(({ done }) => done)
    || (window.badges && window.badges
      .find(({ name }) => name === learningModulesRedux[lmIndex].badge.badge)?.acquired);

  const didCompleteQuiz = (window.badges && window.badges.length && window.badges
    .find(({ name }) => name === learningModulesRedux[lmIndex].badge.badge)?.acquired)
    || hasPassedLmQuiz
    || lmQuiz.every(({ answered }) => answered);

  return (
    <Container>
      <SectionTitleContainer>
        <Title
          style={{
            fontSize: didCompleteLessons && didCompleteQuiz ? 19 : 24
          }}
        >
          {learningModulesRedux[lmIndex].title}
        </Title>
        {
          didCompleteLessons
          && didCompleteQuiz
          && (
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
              <Done />
              <h2
                style={{
                  fontSize: 18,
                  color: process.env.REACT_APP_COLOR_RC_GREEN
                }}
              >
                {__('app.completed')}
              </h2>
            </div>
          )
        }
      </SectionTitleContainer>
      <BodyText>
        {learningModulesRedux[lmIndex].description}
      </BodyText>
      {
        lessons
          ? (
            <Content aria-label="Learning Modules lessons list" ref={lessonContentRef}>
              {
                Object
                  .keys(lessons)
                  .map((key) => lessons[key])
                  .sort((a, b) => viewedLearningModules.includes(a?.activityId)
                    - viewedLearningModules.includes(b?.activityId))
                  .map(({
                    title,
                    id,
                    done,
                    activityId
                  }) => (
                    <Lesson
                      key={id}
                      id={id}
                      title={title}
                      onClick={() => onClick(activityId)}
                      data={activityId}
                      status={done ? 'done' : 'ready'}
                      type="RF"
                      ref={lessonRef}
                    />
                  ))
              }
            </Content>
          ) : null
      }
      {
        lessons
          && lmQuiz
          && didCompleteLessons
          && !hasPassedLmQuiz
          && !accountId
          ? (
            <TakeTheQuizContainer>
              <CustomButton
                type="button"
                className="btn filled royal"
                onClick={createAccount}
              >
                {__('app.please_create_account_to_continue')}
              </CustomButton>
            </TakeTheQuizContainer>
          ) : null
      }

    </Container>
  );
};

const mapStateToProps = (store) => ({
  learningModulesRedux: store.app?.learningModulesRedux || [],
  notificationData: store.other?.notificationData || [],
});

export default connect(mapStateToProps, null)(LearningModules);
